import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e3d5e3d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "info block-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-tit" }, "申请详情", -1))
const _hoisted_4 = { class: "block-con" }
const _hoisted_5 = {
  key: 0,
  class: "pics"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "submit-btn"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "submit-btn"
}

import { projectItem, staffItem, flowsItem, approveStaff, Approve } from '@/apis/base'
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const type_name = ref('--')
const declarationData = ref({
  details: [], //
  pics: null,
  approve_state: 0,
  staff_id: 0, // 发起人id
  tabsActive: 0, // 已发起
  type_id: 0, // 项目类型
  item_id: 0, // 详情id
  approve: {} as Approve,
  project: {} as projectItem,
  flows: Array<flowsItem>()
})
const StaffInfo = ref({
  id: 0,
  name: '',
  avatar: ''
})
const showBottom = ref(false)
onMounted(() => {
  StaffInfo.value = JSON.parse(localStorage.getItem('STAFFINFO'))
  declarationData.value = JSON.parse(router.currentRoute.value.query.data.toString())
  type_name.value = router.currentRoute.value.query.type_name.toString()
  let botton: any = router.currentRoute.value.query.button
  showBottom.value = botton
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_DetailTitle = _resolveComponent("DetailTitle")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_PreviewPicture = _resolveComponent("PreviewPicture")!
  const _component_ApprovalProcess = _resolveComponent("ApprovalProcess")!
  const _component_BottomButtonTwo = _resolveComponent("BottomButtonTwo")!
  const _component_BottomButtonOne = _resolveComponent("BottomButtonOne")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createVNode(_component_DetailTitle, {
      approve: declarationData.value.approve
    }, null, 8, ["approve"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_cell_group, {
          title: "项目名称",
          border: false,
          class: "mx-box"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: declarationData.value?.project?.name,
              size: "large"
            }, null, 8, ["title"])
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(declarationData.value.details, (e, i) => {
          return (_openBlock(), _createBlock(_component_van_cell_group, {
            title: '费用明细' + (i + 1),
            border: false,
            key: i
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_cell, {
                title: "报销内容",
                value: e.type.name
              }, null, 8, ["value"]),
              _createVNode(_component_van_cell, {
                title: "报销事由",
                value: e.explain
              }, null, 8, ["value"]),
              _createVNode(_component_van_cell, {
                title: "日期",
                value: e.created_at
              }, null, 8, ["value"]),
              _createVNode(_component_van_cell, {
                title: "金额（元）",
                value: e.money
              }, null, 8, ["value"])
            ]),
            _: 2
          }, 1032, ["title"]))
        }), 128)),
        (declarationData.value.pics)
          ? (_openBlock(), _createBlock(_component_van_cell_group, {
              key: 0,
              title: "图片",
              border: false
            }, {
              default: _withCtx(() => [
                (declarationData.value.pics)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_PreviewPicture, {
                        imgs: declarationData.value.pics,
                        radius: 5,
                        width: 65,
                        height: 65
                      }, null, 8, ["imgs"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ApprovalProcess, {
      flows: declarationData.value.flows
    }, null, 8, ["flows"]),
    (declarationData.value.tabsActive == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (declarationData.value.approve.approve_staff?.id === StaffInfo.value.id && declarationData.value.approve.state == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (showBottom.value)
                  ? (_openBlock(), _createBlock(_component_BottomButtonTwo, {
                      key: 0,
                      typeId: declarationData.value.type_id,
                      itemId: declarationData.value.item_id
                    }, null, 8, ["typeId", "itemId"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (declarationData.value.tabsActive == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (declarationData.value.approve.staff_id === StaffInfo.value.id && declarationData.value.approve.state == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (showBottom.value)
                  ? (_openBlock(), _createBlock(_component_BottomButtonOne, {
                      key: 0,
                      typeId: declarationData.value.type_id,
                      itemId: declarationData.value.item_id
                    }, null, 8, ["typeId", "itemId"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})